<template lang="pug">
.ride-month-template
  .app-use-logo(v-if="isApp")
    .app-use-logo-text APP专享
  .wait-bg(v-if="status === statusEnum.waitForReceive")
  .ride-card(:class="type +' '+ status")
    .card-logo(v-if="!isOneCentRide")
    .card-info
      .card-info-line-one
        span {{cardDetail.heading}}
        span {{cardDetail.title}}
        span(v-if="rideStatue===0 && isOpen && !isOneCentRide") ·生效中
      .card-info-line-two
        span {{cityNames||'全国通用'}}｜{{cardDetail.subTitle}}
    .ride-num()
      .just-one-per-cent(v-if="isOneCentRide && !isOpen")
        HighlightText(
          text="单单{0.01}元"
          :normalStyle="normalStyle"
          :highlightStyle="highlightStyle")
      .have-day(v-if="rideDays>0&&cardsStatus===2 && status !== statusEnum.waitForReceive")
        .small-sign 剩
        .big-num {{totalCardTimes?rideTimes:rideDays}}
        .small-sign {{totalCardTimes?'次':'天'}}
      .no-day(
        v-else-if="rideDays===0&&cardsStatus===2 && status !== statusEnum.waitForReceive"
      ) 今日到期
      .can-use(v-else-if="showRideCardTouting && isOpen && status !== statusEnum.waitForReceive"
        @click="goUse"
        :class="'can-use-v2'") {{env.isEasyBikeApp?'领取':'去APP使用'}}
    .toOpen(v-if="status === statusEnum.waitForReceive" @click="goMycard")
      .suo_icon
      .text 待生效
    slot
</template>
<script>
import { env } from '@hb/hbridge';
import config from '@/const/config';
import eventBus from '@/const/eventBus.js';
import { PropVersionMap } from '@/const/vip';
import { HighlightText } from '@hb/platformui-h5';
import { RIDE_CARD_STATUS } from '../../consts';

const CARD_DETAIL_CONFIG = {
  ride: {
    title: '30天不限次卡',
    subTitle: '单笔抵120分钟',
    heading: '单车',
  },
  ebike: {
    title: '30天6次卡',
    subTitle: '单笔抵3元',
    heading: '助力车',
  },
  oneCentRide: {
    title: '30天不限次卡',
    subTitle: '前120分钟仅0.01元',
    heading: '单车',
  },
};

export default {
  name: 'RideMonthTemplate',
  components: {
    HighlightText,
  },
  props: {
    type: {
      type: String,
      default: 'ride',
    },
    status: {
      type: String,
      default: '',
    },
    totalCardDays: {
      type: Number,
      default: 0,
    },
    totalCardTimes: {
      type: Number,
      default: 0,
    },
    rideStatue: {
      type: Number,
      default: 0,
    },
    cityNames: {
      type: String,
      default: '全国通用',
    },
    rideFreeMinute: {
      type: String,
      default: '',
    },
    cardsStatus: {
      type: Number,
      default: 0,
    },
    rideTimes: {
      type: Number,
      default: 0,
    },
    rideDays: {
      type: Number,
      default: 0,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    showRideCardTouting: {
      type: Boolean,
      default: false,
    },
    cardStatus: {
      type: Number,
      default: 0,
    },
    cardInfo: {
      type: Object,
      default: () => ({}),
    },
    rideCardInfoValue: {
      type: Boolean,
      default: false,
    },
    isLotteryNew: {
      type: Boolean,
      default: false,
    },
    payAmount: {
      type: Number,
      default: 0,
    },
    isApp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusEnum: {
        receivable: 'receivable',
        waitForReceive: 'wait-for-receive',
      },
      cardMap: RIDE_CARD_STATUS,
      customTitle: '', // 用于聚合卡片的自定义标题
    };
  },
  inject: ['getPropVersion'],
  computed: {
    isOneCentRide() {
      if (this.isOpen) {
        return this.payAmount > 0;
      }
      return this.getPropVersion() === PropVersionMap.RIDE_ONE_CENT;
    },
    cardDetail() {
      const cardType = this.isOneCentRide ? 'oneCentRide' : this.type;
      const tempCardDetail = CARD_DETAIL_CONFIG[cardType] || CARD_DETAIL_CONFIG.ride;

      // 聚合卡片
      if (this.customTitle) {
        tempCardDetail.title = this.customTitle;
      } else if (this.isOpen && this.rideCardInfoValue) {
        // 开卡
        if (Number(this.payAmount) > 0) {
          // 1分骑或其他单单xx元场景
          tempCardDetail.subTitle = `前${this.rideFreeMinute}仅${this.payAmount}元`;
        } else {
          tempCardDetail.subTitle = this.rideFreeMinute ? `单笔抵${this.rideFreeMinute}` : '';
        }
        tempCardDetail.title = `${this.totalCardDays || 30}天${this.totalCardTimes || '不限'}次卡`;
      }
      return tempCardDetail;
    },
    normalStyle() {
      return {
        fontWeight: 500,
        fontSize: '0.15rem',
        color: '#fff',
      };
    },
    highlightStyle() {
      return {
        fontWeight: 400,
        fontSize: '0.2rem',
        color: '#fff',
        fontFamily: 'DIN Alternate Bold',
      };
    },
  },
  watch: {},
  created() {
    eventBus.$on('chooseAggCard', (card) => {
      if (Object.keys(card).length > 0) {
        this.customTitle = `${card.propEffectiveDays}天${card.propTimes}次卡`;
      }
    });
  },
  methods: {
    goMycard() {
      if (env.isEasyBikeApp) {
        window.location.href = 'hellobike://hellobike.com/moped/business/htr_my_card_page';
      } else {
        window.location.href = `https://m.hellobike.com/AppHelloBikeMainH5/${config.env !== 'pro' ? `${config.env}/` : ''}latest/index.html#/my-cards?adsource=`;
      }
    },
    goUse() {
      this.$emit('goUse');
    },
  },

};
</script>
<style lang="less" scoped>
.ride-month-template {
  position: relative;

  .wait-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 0.72rem;
    opacity: 0.5;
    border-radius: 0.1rem;
    background:
      linear-gradient(
        90deg,
        rgba(0, 136, 255, 0.1) 26.17%,
        rgba(0, 136, 255, 0.485133) 38.93%,
        rgba(0, 114, 220, 0.691433) 59.13%,
        rgba(0, 57, 203, 0.8) 83.64%
      );
  }

  .ride-card {
    margin-top: 0.1rem;
    border-radius: 0.1rem;
    height: 0.72rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .card-info {
      flex-grow: 1;
    }

    &.wait-for-receive {
      background: #3bf;
      color: #fff;
      margin-top: 0.08rem;
    }

    .card-logo {
      width: 0.58rem;
      height: 100%;
      margin-right: 0.08rem;
    }

    &.receivable.ebike {
      background: linear-gradient(223deg, #25c0f5 0%, #00afea 100%);
      color: white;

      .card-logo {
        background: url('https://m.hellobike.com/resource/gallery/61/80-OynoJPC.png?x-oss-process=image/quality,q_80') left top no-repeat;
        background-size: 100% 100%;
      }
    }

    &.receivable.ride {
      background: linear-gradient(223deg, #3bf 0%, #33a0ff 100%);
      color: white;

      .card-logo {
        background: url('https://m.hellobike.com/resource/gallery/61/8FQNAEvw07.png?x-oss-process=image/quality,q_80') left top no-repeat;
        background-size: 100% 100%;
      }
    }

    &.receivable.oneCentRide {
      background-image: url('https://m.hellobike.com/c1ae489b15.png');
      background-size: 100% 100%;
      color: white;
      padding-left: 0.2rem;
    }

    &.wait-for-receive.ride {
      .card-logo {
        background: url('https://m.hellobike.com/resource/gallery/61/8FQNAEvw07.png?x-oss-process=image/quality,q_80') left top no-repeat;
        background-size: 100% 100%;
      }
    }

    &.wait-for-receive.ebike {
      .card-logo {
        background: url('https://m.hellobike.com/resource/gallery/61/80-OynoJPC.png?x-oss-process=image/quality,q_80') left top no-repeat;
        background-size: 100% 100%;
      }
    }

    &.wait-for-receive.oneCentRide {
      background-image: url('https://m.hellobike.com/c1ae489b15.png');
      background-size: 100% 100%;
      padding-left: 0.2rem;
    }

    .card-status-info {
      background: #b5c0cb;
      font-size: 0.12rem;
      color: white;
      align-self: flex-start;
      border-top-right-radius: 0.1rem;
      border-bottom-left-radius: 0.1rem;
      padding: 0 0.08rem;
      display: flex;
      white-space: nowrap;
      align-items: center;
    }

    .card-info-line-two {
      font-size: 0.12rem;
      opacity: 0.7;
    }

    .card-info-line-one {
      font-size: 0.15rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.06rem;
      font-weight: 500;
    }

    .dot {
      content: '';
      display: inline-block;
      width: 0.04rem;
      height: 0.04rem;
      background: white;
      border-radius: 50%;
      margin: 0 0.04rem;
      white-space: nowrap;
    }

    .ride-num {
      position: absolute;
      top: 0.26rem;
      right: 0.2rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.12rem;
      font-weight: 500;
      color: #fff;
      height: 0.24rem;
      line-height: 0.24rem;

      .have-day {
        display: flex;
        align-items: baseline;

        .big-num {
          font-family: "DIN Alternate Bold", sans-serif;
          font-size: 0.2rem;
          font-weight: 700;
        }

        .small-sign {
          line-height: 0.24rem;
        }
      }

      .can-use-v2 {
        min-width: 0.74rem;
        height: 0.32rem;
        background: #fff;
        color: #08f;
        font-size: 0.15rem;
        text-align: center;
        border-radius: 0.26rem;
        line-height: 0.32rem;
      }
    }

    .toOpen {
      position: absolute;
      top: 50%;
      right: 0.18rem;
      transform: translateY(-50%);
      min-width: 0.8rem;
      height: 0.26rem;
      background-image: url(https://m.hellobike.com/resource/gallery/350/NZmUDRI3_anniua.png);
      background-size: 100%;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;

      .suo_icon {
        width: 0.14rem;
        height: 0.14rem;
        background-image: url(https://m.hellobike.com/resource/gallery/350/nXEaENeU_suo.png);
        background-size: 100%;
        background-repeat: no-repeat;
        margin-left: 0.11rem;
      }

      .text {
        font-weight: 400;
        font-size: 0.13rem;
        line-height: 100%;
        margin-left: 0.04rem;
        color: rgba(0, 0, 0, 1);
      }
    }
  }

  .app-use-logo {
    position: absolute;
    right: 0;
    top: 0;
    width: 0.51rem;
    height: 0.17rem;
    background: linear-gradient(90deg, #fff5e2 0%, #ffcab7 100%);
    border: 0.005rem solid #fff;
    border-radius: 0 0.1rem 0 0.1rem;
    z-index: 2;

    .app-use-logo-text {
      font-size: 0.1rem;
      color: #000;
      line-height: 0.17rem;
      text-align: center;
      font-weight: 600;
    }
  }
}
</style>
